export default {
  nav: {
    home: 'Startseite',
    categories: 'Kategorien',
    guide: 'Leitfaden',
    review: 'Bewertung',
    shipping: 'Versand',
    safety: 'Sicherheit',
    faq: 'FAQ',
    cta: 'Hauptseite besuchen',
    shoppingGuide: 'Einkaufsführer',
  },
  hero: {
    badge: 'Aktualisiert für 2026 · Unabhängige Ressource',
    title: 'AllChinaBuy Spreadsheet — Produkte, Links und QC schneller finden',
    subtitle:
      'Entdecken Sie die neuesten AllChinaBuy-Spreadsheet-Ressourcen, Produktfunde, nützliche Links, QC-Informationen, Kaufratgeber und Versandressourcen an einem Ort.',
    ctaPrimary: 'AllChinaBuy Spreadsheet',
    ctaSecondary: 'Jetzt kaufen',
    searchPlaceholder: 'Produkte, Kategorien oder Guides suchen...',
  },
  categories: {
    title: 'Beliebte Kategorien',
    subtitle: 'Springen Sie direkt zu den Produkten und Links, die Sie brauchen, im Haupt-Spreadsheet.',
    dropdownLabel: 'Nach Kategorie durchsuchen',
    dropdownPlaceholder: 'Kategorie wählen',
    visit: 'Auf der Hauptseite ansehen',
  },
  cat: {
    shoes: 'Schuhe',
    hoodies: 'Hoodies / Sweatshirts',
    tshirts: 'T-Shirts',
    jackets: 'Jacken',
    pants: 'Hosen / Shorts',
    headwear: 'Kopfbedeckungen',
    sets: 'Sets',
    underwear: 'Unterwäsche',
    jersey: 'Trikot',
    accessories: 'Accessoires',
    bags: 'Taschen',
    belts: 'Gürtel',
    perfumes: 'Parfums',
    other: 'Sonstiges',
  },
  info: {
    sectionTitle: 'Alles über das AllChinaBuy Spreadsheet',
    whatTitle: 'Was ist das AllChinaBuy Spreadsheet?',
    whatBody:
      'Das AllChinaBuy-Spreadsheet ist eine kuratierte Sammlung von Produktfunden, funktionierenden Links, QC-Fotos und Versandnotizen in einem organisierten Blatt. Statt endlose Threads zu durchforsten, öffnen Käufer ein einziges Blatt, um Artikel aus Schuhen, Hoodies, T-Shirts, Jacken, Taschen und mehr zu sehen — jede Zeile zeigt das Produkt, seinen Link, die Preisspanne und den QC-Status.',
    howTitle: 'So funktioniert es',
    howBody:
      'Öffnen Sie das Blatt, wählen Sie eine Kategorie aus dem Dropdown oder dem Raster und springen Sie zum gewünschten Artikel. Jedes Produkt verlinkt direkt auf den Hauptshop, sodass Sie Details prüfen, Optionen vergleichen und mit wenigen Klicks bestellen können. Das Layout ist auf Tempo ausgelegt: finden, QC-Foto prüfen, Link kopieren, fertig.',
    reviewTitle: 'Warum Käufer es lieben',
    reviewBody:
      'Nutzer kommen immer wieder zum Blatt zurück, weil es Stunden Suche spart und das Rätselraten beseitigt. Die nützlichste Version kombiniert echtes Käuferfeedback mit aktuellen QC-Fotos, sodass Sie wissen, was Sie bekommen, bevor Sie bezahlen. Es ist ein Recherchewerkzeug, kein Shop — der endgültige Kauf erfolgt auf der Hauptseite.',
    shippingTitle: 'Versandkosten & Lager',
    shippingBody:
      'Die Versandkosten hängen vom Artikel, seinem Gewicht und der gewählten Versandlinie ab. Das Blatt gruppiert Artikel nach Kategorie, sodass Sie ähnliche Produkte vergleichen und eine Sammelbestellung planen können, um die Versandkosten pro Artikel zu senken. Prüfen Sie die Lager- und Versandabschnitte für aktuelle Methoden und Spartipps.',
    qcTitle: 'QC & Produktprüfung',
    qcBody:
      'Die Qualitätskontrolle ist der Schritt, der Ihre Bestellung schützt. Achten Sie auf Blätter mit QC-Fotos, Maßen und Verkäufernotizen, bevor Sie sich festlegen. Hat ein Angebot keine QC-Daten, behandeln Sie es mit Vorsicht und bitten Sie den Verkäufer zuerst um Fotos.',
    safetyTitle: 'Sicherheitscenter',
    safetyBody:
      'Dies ist eine unabhängige Informationsressource und ist weder mit AllChinaBuy verbunden noch von ihm betrieben. Achten Sie auf gefälschte Blätter und Phishing-Links. Verwenden Sie nur Links von der Hauptseite und geben Sie niemals Ihre Anmelde- oder Zahlungsdaten auf unbekannten Seiten ein.',
  },
  article: {
    badge: 'Kompletter Leitfaden',
    title: 'AllChinaBuy Spreadsheet: Kompletter Leitfaden zu Funden, Links & QC',
    desc:
      'Ein vollständiger Überblick darüber, was das AllChinaBuy-Spreadsheet ist, was darin enthalten ist, wie man es nutzt und wie man Produkte sicher prüft, bevor man bestellt.',
    cta: 'Den vollständigen Leitfaden lesen',
    readTime: '8 Min. Lesezeit',
    updated: 'Zuletzt aktualisiert',
  },
  faq: {
    title: 'Häufig gestellte Fragen',
    q1: 'Ist das AllChinaBuy Spreadsheet kostenlos?',
    a1: 'Das Blatt ist eine kostenlose Informationsressource. Sie können hier Kategorien und Links durchsuchen, und der endgültige Kauf erfolgt auf der Hauptseite.',
    q2: 'Ist diese Website mit AllChinaBuy verbunden?',
    a2: 'Nein. Dies ist eine unabhängige Informationsressource. Wir sind weder mit AllChinaBuy verbunden noch von ihm betrieben.',
    q3: 'Wie prüfe ich die QC eines Produkts?',
    a3: 'Achten Sie auf QC-Fotos, Maße und Verkäufernotizen im Angebot. Hat ein Produkt keine QC-Daten, bitten Sie den Verkäufer vor der Bestellung um Fotos.',
    q4: 'Wie senke ich die Versandkosten?',
    a4: 'Bündeln Sie mehrere Artikel in einer Bestellung, wählen Sie eine passende Versandlinie und vergleichen Sie ähnliche Produkte in derselben Kategorie, bevor Sie sich festlegen.',
    q5: 'Sind die Produktlinks sicher?',
    a5: 'Verwenden Sie nur Links von der Hauptseite. Vermeiden Sie Drittanbieter- oder gekürzte Links und geben Sie niemals Anmelde- oder Zahlungsdaten auf unbekannten Seiten ein.',
  },
  footer: {
    about:
      'Eine unabhängige Informationsressource für AllChinaBuy-Spreadsheet-Funde, Links, QC-Fotos und Versandguides. Wir sind weder mit AllChinaBuy verbunden noch von ihm betrieben.',
    linksTitle: 'Schnelllinks',
    categoriesTitle: 'Kategorien',
    disclaimer:
      'Dies ist eine unabhängige Informationsressource und ist weder mit AllChinaBuy verbunden noch von ihm betrieben.',
    rights: 'Alle Rechte vorbehalten.',
  },
  pillar: {
    title: 'Pillar-Guides & Vertiefungen',
    subtitle: 'Originale, fundierte Guides, um mit dem AllChinaBuy Spreadsheet intelligenter und sicherer einzukaufen.',
    read: 'Guide lesen',
  },
  guide: {
    notFound: 'Guide nicht gefunden',
    notFoundDesc: 'Der gesuchte Guide existiert nicht. Gehen Sie zur Startseite zurück, um alle Guides zu durchsuchen.',
    ctaTitle: 'Bereit, die neuesten Funde zu entdecken?',
    ctaDesc: 'Entdecken Sie jede Kategorie und springen Sie direkt zu den Produkten der Hauptseite.',
    related: 'Verwandte Guides',
  },
  common: {
    explore: 'Entdecken',
    learnMore: 'Mehr erfahren',
    backHome: 'Zurück zur Startseite',
    readArticle: 'Leitfaden lesen',
  },
};